// Photos du site, et la seule règle qui les gouverne : UN ALT NE MENT PAS.
//
// ─────────────────────────────────────────────────────────────────────────────
// CE QUI A ÉTÉ CORRIGÉ, ET POURQUOI CE N'EST PAS UN DÉTAIL
// ─────────────────────────────────────────────────────────────────────────────
//
// F6 du plan correctif du 29/08/2026. Les photos de service viennent
// d'Unsplash — ce qui est parfaitement légitime — mais leurs `alt` les
// attribuaient à Gramme : « Camion de déménagement professionnel Déménagements
// Gramme » sur une photo de banque d'images, « Entrepôt garde-meubles sécurisé
// Déménagements Gramme à Seraing » sur un entrepôt qui n'est pas le leur.
//
// Sur un site quelconque, ce serait une maladresse. Sur celui-ci, c'est une
// contradiction : tout le dispositif construit une couche de PROVENANCE — les
// règles de stationnement de cinquante et une communes, relevées avec leur
// autorité, leur source officielle et leur date de relevé — pour être citable
// par des assistants. Un `alt` qui attribue une photo de stock à l'entreprise
// est exactement la chose que cette couche est censée rendre impossible.
//
// Les `alt` décrivent donc ce qu'on voit, sans revendiquer ce qu'on ne sait
// pas. Le hero, lui, est une VRAIE photo d'un camion Gramme, hébergée sur le
// domaine : il est le seul à porter le nom de l'entreprise, et il a le droit.
//
// Trois avatars de témoignage ont été retirés purement et simplement : c'étaient
// des portraits de banque d'images légendés « Avatar client Marie L. », donc
// des clients fabriqués. Aucun composant ne les utilisait — ils attendaient
// seulement que quelqu'un les branche.
//
// TODO: remplacer les photos restantes (équipe, dépôt, emballage) par de
// vraies photos de Déménagements Gramme. Le jour où c'est fait, les `alt`
// peuvent redevenir nominatifs.

/** Construit une URL Unsplash à la largeur et à la qualité voulues. */
const unsplash = (id: string, w: number, q = 70) =>
  `https://images.unsplash.com/${id}?w=${w}&q=${q}&auto=format&fit=crop`;

/** Génère un srcset à partir d'une liste de largeurs. */
const srcSet = (id: string, widths: number[], q = 70) =>
  widths.map((w) => `${unsplash(id, w, q)} ${w}w`).join(', ');

const HERO_WIDTHS = [640, 828, 1200, 1600];
/** Srcset local pour la photo du hero, déclinée en public/hero/. */
const heroSet = (ext: string) =>
  HERO_WIDTHS.map((w) => `/hero/demenagement-liege-${w}.${ext} ${w}w`).join(', ');

export const SITE_IMAGES = {
  // Vraie photo d'un camion Gramme, hébergée sur le domaine — plus de
  // dépendance à Unsplash pour l'image la plus visible du site, et le
  // marquage de l'entreprise est enfin authentique.
  //
  // Déclinée en 4 largeurs et 3 formats (AVIF, WebP, JPEG) : le navigateur
  // n'en télécharge qu'une. En AVIF, un mobile prend 19 à 31 Kio.
  hero: {
    src: '/hero/demenagement-liege-1200.jpg',
    srcSetAvif: heroSet('avif'),
    srcSetWebp: heroSet('webp'),
    srcSetJpeg: heroSet('jpg'),
    // Alt de l'accueil. Les pages communes passent le leur à HeroSection.
    alt: 'Camion de Déménagements Gramme, votre déménageur à Liège depuis 1948',
  },
  // Photo affichée en ~343 px de large sur mobile et ~600 px sur desktop,
  // mais servie en 900 px fixes et sans srcset. Elle apparaît deux fois
  // (section « Pourquoi nous » et bloc contact), ce qui en faisait la plus
  // lourde des images restantes après l'optimisation du hero.
  team: {
    src: unsplash('photo-1566576721346-d4a3b4eaeb55', 600, 65),
    srcSet: srcSet('photo-1566576721346-d4a3b4eaeb55', [400, 600, 900], 65),
    // Photo de banque d'images : l'alt décrit la scène, il ne l'attribue pas.
    alt: 'Camion de déménagement chargé devant un immeuble',
  },
  truck: {
    src: 'https://images.unsplash.com/photo-1566576721346-d4a3b4eaeb55?w=900&q=75&auto=format&fit=crop',
    alt: 'Camion de déménagement chargé devant un immeuble',
  },
  warehouse: {
    src: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=900&q=75&auto=format&fit=crop',
    alt: 'Allée de box de stockage individuels fermés',
  },
  packing: {
    src: 'https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=900&q=75&auto=format&fit=crop',
    alt: 'Cartons d\'emballage empilés et vaisselle protégée',
  },
} as const;
